import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider, ReactReduxContext } from 'react-redux';
import store from './store/store';
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./constants/auth/authConfig"
import { PublicClientApplication } from "@azure/msal-browser";

const root = ReactDOM.createRoot(document.getElementById('root'));
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <React.StrictMode>
        <MsalProvider instance={msalInstance}>
      <Provider store={store} context={ReactReduxContext} >
        <App />
      </Provider>
      </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
